module.exports = __webpack_public_path__ + "img/brand_title.a52d3aec.png";